import Joi from "joi";

const validation = Joi.object({
  // Campos del certificado de escrutinio
  electores_votaron: Joi.number().min(0).allow(''),
  sobres_urna: Joi.number().min(0).allow(''),
  diferencia_votos: Joi.number().allow(''),

  // Campos legacy (mantener compatibilidad)
  electores: Joi.number().min(0).allow(''),

  especiales: Joi.object({
    nulos: Joi.number().min(0).allow(''),
    recurridos: Joi.number().min(0).allow(''),
    impugnados: Joi.number().min(0).allow(''),
    blancos: Joi.number().min(0).allow('')
  }),
  detalle: Joi.array().items(Joi.object({
    lista: Joi.string(),
    presidente: Joi.number().min(0).allow(''),
    diputados_nacionales: Joi.number().min(0).allow(''),
    legisladores_provinciales: Joi.number().min(0).allow(''),
    concejales: Joi.number().min(0).allow('')
  }))
}).unknown(true);

export default validation;
